import { useMutation } from '@apollo/client';

import type { Transaction } from '__generated__/GQL';
import { logEvent } from 'features/Analytics/analytics';

import { UnlinkInvoiceDocument } from './graphql/unlinkInvoice.gql';

interface Params {
  transactionId: string;
  transactionType: Transaction['type'];
}

const useUnlinkInvoiceMutation = ({
  transactionId,
  transactionType,
}: Params) => {
  const [mutation, hook] = useMutation(UnlinkInvoiceDocument);

  const unlinkInvoice = (invoiceId: string) =>
    mutation({
      onCompleted: () => {
        logEvent({
          name: 'Transaction Receipt Deleted',
          properties: {
            invoiceId,
            source: 'web-app',
            transactionId,
            transactionType,
            type: 'ShineInvoice',
          },
          usePrefix: false,
        });
      },
      variables: {
        input: {
          invoiceId,
          transactionId,
        },
      },
    });

  return [unlinkInvoice, hook] as const;
};

export default useUnlinkInvoiceMutation;
